<template>
  <BasePage>
    <div class="px-4 py-8 max-w-3xl mx-auto">
      <div v-if="product">
        <img v-if="product.imageUrl" :src="product.imageUrl" :alt="product.name" class="w-full max-w-48 mx-auto rounded-lg shadow-md mb-6" />
        <div v-else class="w-full max-w-48 h-48 mx-auto rounded-lg border border-slate-200 bg-slate-50 text-slate-500 flex items-center justify-center text-sm font-semibold mb-6">
          App Preview Coming Soon
        </div>
        <h1 class="text-3xl font-bold text-center mb-2">{{ product.name }}</h1>
        <p class="text-center text-md md:text-lg text-gray-600 mb-4">{{ product.tagline }}</p>
        <div
          v-if="product.legacy"
          class="mb-6 rounded-lg border border-slate-300 bg-slate-100 px-4 py-3 text-sm md:text-base text-slate-800"
        >
          <p class="font-semibold">Legacy app notice</p>
          <p class="mt-1">
            This app is now part of
            <router-link :to="'/products/' + (product.replacementSlug || 'mdm-calc')" class="text-blue-700 hover:underline">
              {{ product.replacementName || "MDM Calc: E/M Optimizer" }}
            </router-link>.
          </p>
        </div>
        <div
          v-if="product.comingSoon"
          class="mb-6 rounded-lg border border-amber-300 bg-amber-50 px-4 py-3 text-sm md:text-base text-amber-900"
        >
          <p class="font-semibold">Coming soon</p>
          <p class="mt-1">MDM Calc is listed now and will be live on the App Store soon.</p>
        </div>
        <div
          v-if="product.guidanceLastUpdated"
          class="mb-6 rounded-lg border border-blue-200 bg-blue-50 px-4 py-3 text-sm md:text-base text-blue-900"
        >
          <p class="font-semibold">Coding guidance last updated: {{ product.guidanceLastUpdated }}</p>
          <p class="mt-1">{{ product.guidanceSummary }}</p>
        </div>
        <div class="text-left space-y-4 text-lg md:text-xl text-gray-500">
          <p v-for="(para, index) in product.paragraphs" :key="index">{{ para }}</p>
        </div>
        <div v-if="product.links?.length" class="mt-8">
          <h2 class="text-xl font-semibold mb-2">Get the app</h2>
          <ul class="space-y-2">
            <li v-for="(link, index) in product.links" :key="index">
              <router-link v-if="isInternal(link.url)" :to="link.url" class="text-blue-600 hover:underline">
                {{ link.label }}
              </router-link>
              <span v-else-if="!link.url" class="text-slate-500">{{ link.label }}</span>
              <a v-else :href="link.url" target="_blank" rel="noopener noreferrer" class="text-blue-600 hover:underline">
                {{ link.label }}
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </BasePage>
</template>

<script setup>
import { useRoute } from "vue-router"
import products from "@/data/products"
import router from "@/router";
import BasePage from "@/components/BasePage.vue"

const route = useRoute()
const product = products.find(p => p.slug === route.params.slug)
const isInternal = (url) => typeof url === "string" && url.startsWith("/")

if (!product || !product.hasDetailPage) {
  router.replace({ name: "page-not-found" })
}
</script>
